"use client";

import {axiosInstance} from "@/app/api";
import {getNeoCookie, setNeoCookie} from "@/libs/helper/cookies";

const onGetClientProfile = async (): Promise<NeoClients> => {
  const selectedClient: Client = await getNeoCookie("neo.client");
  const clientProfileResponse: NeoClients = onGetClientProfileResponse();
  return await axiosInstance()
    .get(`api/profile?appType=${process.env.NEXT_PUBLIC_NEO_APP_TYPE}`)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<INeoClients> = response.data;
        if (
          neoresponse &&
          neoresponse.data &&
          neoresponse.data?.usersMeta?.length > 0
        ) {
          clientProfileResponse.clients =
            neoresponse.data?.usersMeta?.map(x => {
              return {
                institutionId: x?.insId,
                institutionUserId: x?.userid,
                institutionName: x?.schName,
                name: x?.name,
                insLat: x.insLat,
                insLng: x.insLng,
                roles: x?.roleAccess,
                institutionUserName: x?.userName,
                institutionUserPhone: x?.phone,
                paymentReminder: x?.paymentReminder,
                currency: x?.currency,
                customerType: x?.customerType ?? 1,
                swFeatures: x?.swFeatures
              };
            }) || [];
          clientProfileResponse.default =
            selectedClient && selectedClient?.institutionId !== null
              ? selectedClient
              : clientProfileResponse.clients[0];
          //console.log(selectedClient);
          if (!selectedClient) {
            setNeoCookie("neo.client", clientProfileResponse.default);
            //console.log("from meta serive profile call");
          }
        }
        if (clientProfileResponse?.default?.institutionId) {
          clientProfileResponse.roles =
            neoresponse.data?.usersMeta?.find(
              ele => ele.insId === clientProfileResponse?.default?.institutionId
            )?.roleAccess ?? null;
          return Promise.all([
            onGetOperators(clientProfileResponse?.default?.institutionId),
            onGetInstVehicles(clientProfileResponse?.default?.institutionId),
            onGetProperties(clientProfileResponse?.default?.institutionId),
            getFleetvehicles(clientProfileResponse?.default?.institutionUserId) // enable once facility api ready
          ]).then(
            ([
              operatorsResponse,
              vehiclesResponse,
              propertiesResponse,
              fleetvehicles
            ]) => {
              clientProfileResponse.lookup.operators =
                operatorsResponse.operators;
              clientProfileResponse.lookup.categories =
                operatorsResponse.categories;
              clientProfileResponse.lookup.vehicles = vehiclesResponse.vehicles;
              clientProfileResponse.lookup.hwFeatures =
                propertiesResponse?.hwFeatures ?? [];
              clientProfileResponse.lookup.uhfHardwareGroups =
                propertiesResponse?.uhfHardwareGroups ?? [];
              //reportCards
              clientProfileResponse.lookup.reportCards =
                propertiesResponse?.reportCards ?? [];
              clientProfileResponse.lookup.fleetVehicle = fleetvehicles; // enable once facility api ready
              return clientProfileResponse;
            }
          );
        }
        return clientProfileResponse;
      }
      return clientProfileResponse;
    })
    .catch((error: any) => {
      return clientProfileResponse;
    });
};

const onGetInstVehicles = async (instituteId: number): Promise<NeoLookup> => {
  return await axiosInstance()
    .get(`/api/vehicles?insId=${instituteId}`)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<VehicleInfo[]> = response.data;
        return {
          vehicles: neoresponse.data ?? []
        };
      } else {
        return {
          vehicles: []
        };
      }
    })
    .catch((error: any) => {
      return {
        vehicles: []
      };
    });
};

// skeleton for facility just change the api endpoint and response path here
const onGetFacility = async (instituteId: number): Promise<NeoLookup> => {
  return await axiosInstance()
    .get(`/api/vehicles?insId=${instituteId}`)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<Facility[]> = response.data;
        return {
          facility: neoresponse.data ?? []
        };
      } else {
        return {
          facility: []
        };
      }
    })
    .catch((error: any) => {
      return {
        facility: []
      };
    });
};

const onGetOperators = async (instituteId: number): Promise<NeoLookup> => {
  return await axiosInstance()
    .get(`/api/operators?instituteId=${instituteId}`)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<NeoLookup> = response.data;
        return {
          operators: neoresponse.data?.operators ?? [],
          categories: neoresponse.data?.categories ?? []
        };
      } else {
        return {
          operators: [],
          categories: []
        };
      }
    })
    .catch((error: any) => {
      return {
        operators: [],
        categories: []
      };
    });
};

const getFleetvehicles = async (userId: any): Promise<any> => {
  const request = {filters: {branch: [userId]}};
  return await axiosInstance()
    .post(`/api/fleet/vehicles/list`, request)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<ExpenseVehicleRes> = response.data;
        const vehicles =
          neoresponse.data?.reportData?.map(item => ({
            trackerId: item.id,
            trackerName: item.regNo,
            ...item
          })) ?? [];
        return vehicles;
      } else {
        return [];
      }
    })
    .catch((error: any) => {
      return [];
    });
};
const onGetProperties = async (instituteId: number): Promise<NeoLookup> => {
  return await axiosInstance()
    .get(`/api/reports/properties?instituteId=${instituteId}`)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        // const neoresponse: NeoResponse<NeoLookup> = response.data;
        // return {
        //   operators: neoresponse.data?.operators ?? [],
        //   categories: neoresponse.data?.categories ?? []
        // };
        return response.data.data;
      } else {
        return {
          hwFeatures: [],
          uhfHardwareGroups: []
        };
      }
    })
    .catch((error: any) => {
      return {
        hwFeatures: [],
        uhfHardwareGroups: []
      };
    });
};
//getInstitutionCreditCoins
const getInstitutionCreditCoins = async (): Promise<any> => {
  return await axiosInstance()
    .get(`/api/credits`)
    .then((response: any) => {
      const neoresponse: NeoResponse<{
        credits: number;
      }> = response.data;
      if (neoresponse.status === "success") {
        return neoresponse.data;
      }
    })
    .catch((error: any) => {
      // return result;
      return null;
    });
};
const onGetHardwareList = async (): Promise<any[]> => {
  return await axiosInstance()
    .get(`/api/hardware/list`)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        return response.data?.data?.reportData ?? [];
      }
      return [];
    })
    .catch((error: any) => {
      return [];
    });
};

export const metaService = {
  onGetClientProfile,
  getInstitutionCreditCoins,
  onGetHardwareList
};

const onGetClientProfileResponse = () => {
  return {
    clients: [],
    default: {
      institutionId: null,
      institutionUserId: null,
      institutionName: null,
      name: null,
      roles: [],
      insLat: null,
      insLng: null,
      institutionUserName: null,
      institutionUserPhone: null,
      paymentReminder: null,
      currency: null,
      swFeatures: null
    },
    lookup: {
      operators: [],
      categories: []
    }
  } as NeoClients;
};
